import type { TabelaHorarioFuncionario } from 'service/api'

/**
 * Localiza a troca de tabela de horário pelo id vindo da rota.
 *
 * O id é sempre string — `"482"` para troca manual, `"7-3"` para troca
 * automática.
 */
export function encontrarTroca(
    trocas: TabelaHorarioFuncionario[] | undefined,
    id: string | undefined,
): TabelaHorarioFuncionario | undefined {
    if (!id) return undefined
    return trocas?.find(troca => String(troca.id) === id)
}
